<template>
  <div
    :id="id"
    :class="[
      'overflow-hidden rounded-lg shadow',
      active ? 'bg-green-600' : 'bg-white',
      clickable && !active ? 'cursor-pointer hover:bg-gray-50' : '',
    ]"
    @click="$emit('click')"
  >
    <div class="h-full relative p-4">
      <div class="h-full flex items-center">
        <div class="h-full w-0 flex-1">
          <div class="h-full flex flex-col justify-between">
            <div class="flex items-center justify-between md:block lg:flex">
              <div
                :class="[
                  'truncate text-sm font-medium',
                  active ? 'text-white' : 'text-gray-900',
                ]"
              >
                {{ label }}
              </div>

              <slot name="label-action"></slot>
            </div>
            <div class="mt-6">
              <div
                :class="[
                  'text-lg font-bold',
                  active ? 'text-white' : 'text-gray-900',
                ]"
                :id="`${id}-value`"
              >
                {{ value | toCurrency }}
              </div>
            </div>
          </div>
        </div>
        <div
          :class="[
            'absolute -bottom-4 -right-3 flex-shrink-0',
            active ? 'text-white' : 'text-gray-200',
          ]"
        >
          <!-- Heroicon name: outline/scale -->
          <svg
            xmlns="http://www.w3.org/2000/svg"
            class="h-16 w-16"
            viewBox="0 0 20 20"
            fill="currentColor"
          >
            <path
              d="M5.5 16a3.5 3.5 0 01-.369-6.98 4 4 0 117.753-1.977A4.5 4.5 0 1113.5 16h-8z"
            />
          </svg>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    label: {
      type: String,
      required: true,
    },
    value: {
      type: null,
      required: true,
    },
    id: String,
    clickable: Boolean,
    active: Boolean,
  },
  emits: ['click'],
};
</script>
